var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerDiv"},[_c('PCNavbar',{attrs:{"selectIndex":"gw2"}}),_c('MobileNavBar',{attrs:{"currentActive":1}}),_c('img',{staticClass:"bannerImgcss0",attrs:{"src":require("../assets/bannner/jituanjianjie.png")}}),_c('div',{staticClass:"production_card"},[_c('gangchan',{staticClass:"menu1css"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }